import { useCallback, useMemo, useState } from 'react';

import { useSetLoyaltyScanAndPayMutation } from 'generated/rbi-graphql';
import { useLoyaltyActiveCard } from 'hooks/loyalty';

export const useLoyaltyScanAndPay = () => {
  const {
    activeCard,
    refetchActiveCard,
    loyaltyDetails,
    loading: loyaltyDetailsLoading,
  } = useLoyaltyActiveCard();
  const userScanAndPayEnabled = useMemo(() => loyaltyDetails?.scanAndPay ?? false, [
    loyaltyDetails,
  ]);

  const [
    setLoyaltyScanAndPayMutation,
    { loading: setLoyaltyScanAndPayLoading },
  ] = useSetLoyaltyScanAndPayMutation({
    onCompleted: async () => {
      await refetchActiveCard();
      setLoading(false);
    },
  });

  const [loading, setLoading] = useState(
    (loyaltyDetailsLoading || setLoyaltyScanAndPayLoading) ?? false
  );

  const updateScanAndPayStatus = useCallback(
    async (newStatus: boolean) => {
      setLoading(true);
      const cardId = activeCard?.cardId ?? '';
      await setLoyaltyScanAndPayMutation({
        variables: { cardId, scanAndPay: newStatus },
      });
    },
    [activeCard, setLoyaltyScanAndPayMutation]
  );

  return {
    userScanAndPayEnabled,
    updateScanAndPayStatus,
    loading,
  };
};
